import {getPointOnTheLine} from "../../../../../helpers/sqftHelper";
import {expandLineAndClosestPoints} from "./expandLineAndClosestPoints";
import {expandLineLeftAndRightParts} from "./expandLineLeftAndRightParts";
import {getClosestLineToPoint} from "../../../helpers/lineHelper";

export const mathRound = (value) => Math.round(value * 100) / 100;

// function horizontalEastLineExpand(prevLine, nextLine, diff) {
//   prevLine.from.x = mathRound(prevLine.from.x - diff/2);
//   prevLine.to.x = mathRound(prevLine.to.x - diff/2);
//   nextLine.from.x = mathRound(nextLine.from.x + diff/2);
//   nextLine.to.x = mathRound(nextLine.to.x + diff/2);
//   if(prevLine.isWithBumpout()) {
//     prevLine.bumpoutOverlay.moveBumpout(diff / 2, 0);
//   }
//   if(nextLine.isWithBumpout()) {
//     nextLine.bumpoutOverlay.moveBumpout(-diff / 2, 0);
//   }
//   if(prevLine.isWithMitered()) {
//     prevLine.miteredOverlay.moveMitered(diff / 2, 0);
//   }
//   if(nextLine.isWithMitered()) {
//     nextLine.miteredOverlay.moveMitered(-diff / 2, 0);
//   }
// }
// function horizontalWestLineExpand(prevLine, nextLine, diff) {
//   prevLine.from.x = mathRound(prevLine.from.x + diff/2);
//   prevLine.to.x = mathRound(prevLine.to.x + diff/2);
//   nextLine.from.x = mathRound(nextLine.from.x - diff/2);
//   nextLine.to.x = mathRound(nextLine.to.x - diff/2);
//   if(prevLine.isWithBumpout()) {
//     prevLine.bumpoutOverlay.moveBumpout(-diff / 2, 0);
//   }
//   if(nextLine.isWithBumpout()) {
//     nextLine.bumpoutOverlay.moveBumpout(diff / 2, 0);
//   }
//   if(prevLine.isWithBumpout()) {
//     prevLine.miteredOverlay.moveMitered(-diff / 2, 0);
//   }
//   if(nextLine.isWithBumpout()) {
//     nextLine.miteredOverlay.moveMitered(diff / 2, 0);
//   }
// }
// function verticalSouthLineExpand(prevLine, nextLine, diff) {
//   prevLine.from.y = mathRound(prevLine.from.y - diff/2);
//   prevLine.to.y = mathRound(prevLine.to.y - diff/2);
//   nextLine.from.y = mathRound(nextLine.from.y + diff/2);
//   nextLine.to.y = mathRound(nextLine.to.y + diff/2);
//   if(prevLine.isWithBumpout()) {
//     prevLine.bumpoutOverlay.moveBumpout(0, diff / 2);
//   }
//   if(nextLine.isWithBumpout()) {
//     nextLine.bumpoutOverlay.moveBumpout(0,-diff / 2);
//   }
// }
// function verticalNorthLineExpand(prevLine, nextLine, diff) {
//   prevLine.from.y = mathRound(prevLine.from.y + diff/2);
//   prevLine.to.y = mathRound(prevLine.to.y + diff/2);
//   nextLine.from.y = mathRound(nextLine.from.y - diff/2);
//   nextLine.to.y = mathRound(nextLine.to.y - diff/2);
//   if(prevLine.isWithBumpout()) {
//     prevLine.bumpoutOverlay.moveBumpout(0,-diff / 2);
//   }
//   if(nextLine.isWithBumpout()) {
//     nextLine.bumpoutOverlay.moveBumpout(0,diff / 2);
//   }
// }


export default function(line, diff, isWallsLockMode) {
  // console.log("line", line, diff);
  //const lineDirection = line.getLineDirection();
  const shape = line.getParent();
  //const prevLine = shape.getPrevLine(line);
  //const nextLine = shape.getNextLine(line);
  if (isWallsLockMode) {
    const lines = shape.getLines();

    //expand first and last line only by moving closest points
    const inflectionPoints = shape.getInflectionPoints();
    if (inflectionPoints) {
      const startPoint = inflectionPoints[0];
      const endPoint = inflectionPoints[inflectionPoints.length - 1];
      const startingLine = getClosestLineToPoint(lines, startPoint);
      const endingLine = getClosestLineToPoint(lines, endPoint);

      if ([startingLine, endingLine].includes(line)) {
        expandLineAndClosestPoints(line, diff);
        return
      }
    }

    //expand predefined shape first and last line only by moving closest points
    const sideLines = shape.getSideLines();
    if (sideLines) {
      const startingLine = sideLines[0];
      const endingLine = sideLines[1];

      if ([startingLine, endingLine].includes(line)) {
        expandLineAndClosestPoints(line, diff);
        return
      }
    }

    expandLineLeftAndRightParts(shape, line, diff);
  } else {
    const pointOnTheLineFrom = getPointOnTheLine(line.from, line.to, diff / 2);
    const pointOnTheLineTo = getPointOnTheLine(line.to, line.from, diff / 2);
    line.to.x = pointOnTheLineTo.x;
    line.to.y = pointOnTheLineTo.y;
    line.from.x = pointOnTheLineFrom.x;
    line.from.y = pointOnTheLineFrom.y;
  }

  // switch (shape.shapeType) {
  //   case "square":
  //     if (lineDirection.orientation === "horizontal") {
  //       if (lineDirection.newDirection === "east") {
  //         horizontalEastLineExpand(prevLine, nextLine, diff);
  //       } else if (lineDirection.newDirection === "west") {
  //         horizontalWestLineExpand(prevLine, nextLine, diff);
  //       }
  //     } else if (lineDirection.orientation === "vertical") {
  //       if (lineDirection.newDirection === "south") {
  //         verticalSouthLineExpand(prevLine, nextLine, diff);
  //       } else if (lineDirection.newDirection === "north") {
  //         verticalNorthLineExpand(prevLine, nextLine, diff);
  //       }
  //     }
  //     break;
  //   case "wideangle": {
  //     const rotatedDegrees = line.getParent().rotatedDegrees;
  //     if (lineDirection.orientation === "horizontal") {
  //       if (lineDirection.newDirection === "east") {
  //         if (rotatedDegrees === 180 || rotatedDegrees === 270) {
  //           prevLine.from.x = mathRound(prevLine.from.x - diff);
  //           prevLine.to.x = mathRound(prevLine.to.x - diff);
  //         } else {
  //           nextLine.from.x = mathRound(nextLine.from.x + diff);
  //           nextLine.to.x = mathRound(nextLine.to.x + diff);
  //         }
  //       } else if (lineDirection.newDirection === "west") {
  //         const nextLineDirection = nextLine.getLineDirection();
  //         if (nextLineDirection.newDirection === "north") {
  //           if (rotatedDegrees === 90) {
  //             prevLine.from.x = mathRound(prevLine.from.x + diff);
  //             prevLine.to.x = mathRound(prevLine.to.x + diff);
  //           } else if (rotatedDegrees === 180 || rotatedDegrees === 270) {
  //             nextLine.from.x = mathRound(nextLine.from.x - diff);
  //             nextLine.to.x = mathRound(nextLine.to.x - diff);
  //           } else {
  //             horizontalWestLineExpand(prevLine, nextLine, diff);
  //           }
  //         } else {
  //           prevLine.from.x = mathRound(prevLine.from.x + diff);
  //           prevLine.to.x = mathRound(prevLine.to.x + diff);
  //         }
  //       }
  //     } else if (lineDirection.orientation === "vertical") {
  //       if (lineDirection.newDirection === "south") {
  //         const prevLineDirection = prevLine.getLineDirection();
  //         if (prevLineDirection.newDirection === "west") {
  //           nextLine.from.y = mathRound(nextLine.from.y + diff);
  //           nextLine.to.y = mathRound(nextLine.to.y + diff);
  //         } else {
  //           if (rotatedDegrees === 90 || rotatedDegrees === 180) {
  //             prevLine.from.y = mathRound(prevLine.from.y - diff);
  //             prevLine.to.y = mathRound(prevLine.to.y - diff);
  //           } else if (rotatedDegrees === 270) {
  //             nextLine.from.y = mathRound(nextLine.from.y + diff);
  //             nextLine.to.y = mathRound(nextLine.to.y + diff);
  //           } else {
  //             verticalSouthLineExpand(prevLine, nextLine, diff);
  //           }
  //         }
  //       } else if (lineDirection.newDirection === "north") {
  //         if (rotatedDegrees === 90 || rotatedDegrees === 180) {
  //           nextLine.from.y = mathRound(nextLine.from.y - diff);
  //           nextLine.to.y = mathRound(nextLine.to.y - diff);
  //         } else {
  //           prevLine.from.y = mathRound(prevLine.from.y + diff);
  //           prevLine.to.y = mathRound(prevLine.to.y + diff);
  //         }
  //       }
  //     } else {
  //       const pointOnTheLineFrom = getPointOnTheLine(line.from, line.to, diff / 2);
  //       const pointOnTheLineTo = getPointOnTheLine(line.to, line.from, diff / 2);
  //       line.to.x = pointOnTheLineTo.x;
  //       line.to.y = pointOnTheLineTo.y;
  //       line.from.x = pointOnTheLineFrom.x;
  //       line.from.y = pointOnTheLineFrom.y;
  //     }
  //     break;
  //   }
  //   case "horseshoe": {
  //     const rotatedDegrees = line.getParent().rotatedDegrees;
  //     const prevLineDirection = prevLine.getLineDirection();
  //     const nextLineDirection = nextLine.getLineDirection();
  //
  //     console.log("-------------------------------");
  //     console.log("line", line);
  //     console.log("diff", diff);
  //     console.log("shape.shapeType", shape.shapeType);
  //     console.log("lineDirection.orientation", lineDirection.orientation);
  //     console.log("lineDirection.newDirection", lineDirection.newDirection);
  //     console.log("prevLineDirection.newDirection", prevLineDirection.newDirection);
  //     console.log("nextLineDirection.newDirection", nextLineDirection.newDirection);
  //     console.log("rotatedDegrees", rotatedDegrees);
  //     if (lineDirection.orientation === "horizontal") {
  //       if (lineDirection.newDirection === "east") {
  //         if (prevLineDirection.newDirection === "north") {
  //           if (rotatedDegrees === 90) {
  //             nextLine.from.x = mathRound(nextLine.from.x + diff);
  //             nextLine.to.x = mathRound(nextLine.to.x + diff);
  //           } else if (rotatedDegrees === 180) {
  //             horizontalEastLineExpand(prevLine, nextLine, diff);
  //           } else if (rotatedDegrees === 270) {
  //             prevLine.from.x = mathRound(prevLine.from.x - diff);
  //             prevLine.to.x = mathRound(prevLine.to.x - diff);
  //           } else {
  //             horizontalEastLineExpand(prevLine, nextLine, diff);
  //             horizontalWestLineExpand(...line.getPairedLines(), diff);
  //           }
  //         } else if (rotatedDegrees === 90) {
  //           nextLine.from.x = mathRound(nextLine.from.x + diff);
  //           nextLine.to.x = mathRound(nextLine.to.x + diff);
  //         } else {
  //           horizontalEastLineExpand(prevLine, nextLine, diff);
  //           horizontalWestLineExpand(...line.getPairedLines(), diff);
  //         }
  //       } else if (lineDirection.newDirection === "west") {
  //         if (prevLineDirection.newDirection === "south") {
  //           if (rotatedDegrees === 90) {
  //             prevLine.from.x = mathRound(prevLine.from.x + diff);
  //             prevLine.to.x = mathRound(prevLine.to.x + diff);
  //           } else if (rotatedDegrees === 180) {
  //             horizontalWestLineExpand(prevLine, nextLine, diff);
  //             horizontalEastLineExpand(...line.getPairedLines(), diff);
  //           } else if (rotatedDegrees === 270) {
  //             nextLine.from.x = mathRound(nextLine.from.x - diff);
  //             nextLine.to.x = mathRound(nextLine.to.x - diff);
  //           } else {
  //             horizontalWestLineExpand(prevLine, nextLine, diff);
  //           }
  //         } else if (rotatedDegrees === 270) {
  //           nextLine.from.x = mathRound(nextLine.from.x - diff);
  //           nextLine.to.x = mathRound(nextLine.to.x - diff);
  //         } else {
  //           horizontalWestLineExpand(prevLine, nextLine, diff);
  //           horizontalEastLineExpand(...line.getPairedLines(), diff);
  //         }
  //       }
  //     } else if (lineDirection.orientation === "vertical") {
  //       if (lineDirection.newDirection === "south") {
  //         if (rotatedDegrees === 180) {
  //           prevLine.from.y = mathRound(prevLine.from.y - diff);
  //           prevLine.to.y = mathRound(prevLine.to.y - diff);
  //         } else {
  //           if (nextLineDirection.newDirection === "west") {
  //             if (rotatedDegrees === 270) {
  //               verticalSouthLineExpand(prevLine, nextLine, diff);
  //               verticalNorthLineExpand(...line.getPairedLines(), diff);
  //             } else {
  //               nextLine.from.y = mathRound(nextLine.from.y + diff);
  //               nextLine.to.y = mathRound(nextLine.to.y + diff);
  //             }
  //           } else {
  //             verticalSouthLineExpand(prevLine, nextLine, diff);
  //             verticalNorthLineExpand(...line.getPairedLines(), diff);
  //           }
  //         }
  //       } else if (lineDirection.newDirection === "north") {
  //         if (prevLineDirection.newDirection === "west") {
  //           if (rotatedDegrees === 90) {
  //             verticalNorthLineExpand(prevLine, nextLine, diff);
  //             verticalSouthLineExpand(...line.getPairedLines(), diff);
  //           } else if (rotatedDegrees === 180) {
  //             nextLine.from.y = mathRound(nextLine.from.y - diff);
  //             nextLine.to.y = mathRound(nextLine.to.y - diff);
  //           } else {
  //             prevLine.from.y = mathRound(prevLine.from.y + diff);
  //             prevLine.to.y = mathRound(prevLine.to.y + diff);
  //           }
  //         } else if (rotatedDegrees === 180) {
  //           nextLine.from.y = mathRound(nextLine.from.y - diff);
  //           nextLine.to.y = mathRound(nextLine.to.y - diff);
  //         } else {
  //           verticalNorthLineExpand(prevLine, nextLine, diff);
  //           verticalSouthLineExpand(...line.getPairedLines(), diff);
  //         }
  //       }
  //     } else {
  //       const pointOnTheLineFrom = getPointOnTheLine(line.from, line.to, diff / 2);
  //       const pointOnTheLineTo = getPointOnTheLine(line.to, line.from, diff / 2);
  //       line.to.x = pointOnTheLineTo.x;
  //       line.to.y = pointOnTheLineTo.y;
  //       line.from.x = pointOnTheLineFrom.x;
  //       line.from.y = pointOnTheLineFrom.y;
  //     }
  //     break;
  //   }
  //   default: {
  //
  //   }
  // }
}

export const getMaxResizeWidth = (line) => {
  const shape = line.getParent();
  switch (shape.shapeType) {
    case "square":
    case "wideangle":
    default:
      break;
    case "horseshoe":
      // const prevLineDirection = prevLine.getLineDirection();
      // const nextLineDirection = nextLine.getLineDirection();
      // const rotatedDegrees = line.getParent().rotatedDegrees;
      // if (lineDirection.orientation === "horizontal") {
      //   if (lineDirection.newDirection === "east") {
      //     if (prevLineDirection.orientation === "vertical" && prevLineDirection.newDirection === "south"
      //       && nextLineDirection.orientation === "vertical" && nextLineDirection.newDirection === "north"
      //         //&& rotatedDegrees !== 180
      //     ) {
      //       const maxRightX = shape.getNextLine(nextLine).to.x;
      //       const maxLeftX = shape.getPrevLine(prevLine).from.x;
      //       return maxRightX - maxLeftX - 2; // 1 per each line, line can't be 0
      //     }
      //   } else if (lineDirection.newDirection === "west") {
      //     if (prevLineDirection.orientation === "vertical" && prevLineDirection.newDirection === "north"
      //       && nextLineDirection.orientation === "vertical" && nextLineDirection.newDirection === "south"
      //       //&& rotatedDegrees !== 0
      //     ) {
      //       const maxRightX = shape.getPrevLine(prevLine).from.x;
      //       const maxLeftX = shape.getNextLine(nextLine).to.x;
      //       return maxRightX - maxLeftX - 2; // 1 per each line, line can't be 0
      //     }
      //   }
      // } else if (lineDirection.orientation === "vertical") {
      //   if (lineDirection.newDirection === "south") {
      //     if (prevLineDirection.orientation === "horizontal" && prevLineDirection.newDirection === "west"
      //       && nextLineDirection.orientation === "horizontal" && nextLineDirection.newDirection === "east"
      //         //&& rotatedDegrees !== 90
      //     ) {
      //       const maxTopY = shape.getPrevLine(prevLine).from.y;
      //       const maxBottomY = shape.getNextLine(nextLine).to.y;
      //       return maxBottomY - maxTopY - 2; // 1 per each line, line can't be 0
      //     }
      //   } else if (lineDirection.newDirection === "north") {
      //     if (prevLineDirection.orientation === "horizontal" && prevLineDirection.newDirection === "east"
      //       && nextLineDirection.orientation === "horizontal" && nextLineDirection.newDirection === "west"
      //      // && rotatedDegrees !== 270
      //     ) {
      //       const maxTopY = shape.getNextLine(nextLine).to.y;
      //       const maxBottomY = shape.getPrevLine(prevLine).from.y;
      //       return maxBottomY - maxTopY - 2; // 1 per each line, line can't be 0
      //     }
      //   }
      // }
      break;
  }
  return "9999";
};
